<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            历史档案
        </div>
        <div style="padding: 20px;">
            <div>
                <div style="float:right">
                    <el-input  placeholder="请输入老人姓名" v-model="name" clearable @change="getList(true)" style="margin:0 10px;width:200px"></el-input>
                    <el-input  placeholder="请输入身份证号" v-model="idCard" clearable @change="getList(true)" style="margin-right:10px;width:200px"></el-input>
                    <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>
            <div style="height: 10px;"></div>
            <div>
                <el-table ref="historicalFilesTable" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                    <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                    <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                    <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                    <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                    <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                    <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                    <el-table-column prop="checkinList" label="入住状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.checkinStatus==2" type="danger">已退住</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="地址" prop="areaName" ></el-table-column>
                    <el-table-column label="详细住址" prop="address" ></el-table-column>
                    
                    <el-table-column fixed="right" label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="success" size="small" @click="handleInfo(scope.row)">入住详情</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
        <el-dialog title='入住详情' :visible.sync="checkinDialog" :modal-append-to-body='false' class="dialog" width='1600px' center top='20vh' :close-on-click-modal='false'>
            <el-table :data="infoData" v-loading="loadingInfo" height="500" border style="width: 100%;">
                <el-table-column prop="elderlyName" label="老人姓名" width="100"></el-table-column>
                    <el-table-column prop="berthNumber" label="床位号"></el-table-column>
                    <el-table-column prop="durationPlan" label="预住时长(天)" width="120"></el-table-column>
                    <el-table-column prop="priceMonth" :formatter="getTofiexd" label="原月费用/元" width="120"></el-table-column>
                    <el-table-column prop="priceMonthDeduction" :formatter="getTofiexd" label="折后月费用/元" width="120"></el-table-column>
                    <el-table-column prop="needVerify"  label="是否需要审核" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.needVerify==0">不需要</span>
                            <span v-if="scope.row.needVerify==1">需要</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="beginTime" :formatter="formatterTime" label="实际入住时间" width="180"></el-table-column>
                    <el-table-column prop="endTime" :formatter="formatterTime" label="实际退住时间" width="180"></el-table-column>
                    <el-table-column prop="beginTimePlan" :formatter="formatterTime1" label="预计入住时间" width="150"></el-table-column>
                    <el-table-column prop="endTimePlan" :formatter="formatterTime1" label="预计退住时间" width="150"></el-table-column>
                    <el-table-column prop="deductionStartTime" :formatter="formatterTime1" label="折扣开始时间" width="150"></el-table-column>
                    <el-table-column prop="deductionEndTime" :formatter="formatterTime1" label="折扣结束时间" width="150"></el-table-column>
                    <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="登记时间"></el-table-column>
                    <el-table-column
                            prop="type"
                            :formatter="typeTitle"
                            label="入住类型" width="100">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            :formatter="statusTitle"
                            label="状态">
                    </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    export default {
        name: 'Add',
        data() {
            return {
                name:'',
                isCard:'',
                bodyStyle:"height:"+(this.$store.state.tableHeight+150)+'px',
                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                loading:false,
                loadingInfo:false,
                th:this.$store.state.tableHeight,
                infoData:[],
                checkinDialog:false
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+150)+'px';
                this.th=val
            },
        },
        created(){
            this.getList();
        },
        components:{},
        methods: {
            init(){
            },
            closeSelf(){
                this.$emit('closeHistoricalFiles')
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,10):null
            },
            statusTitle(row) {
                if (row.status == 0) {
                    return "已预约";
                }
                if (row.status == 1) {
                    return "入住中";
                }
                if (row.status == 2) {
                    return "已退住";
                }
                return "其它";
            },
            typeTitle(row) {
                if (row.type == 0) {
                    return "正式入住";
                }
                if (row.type == 1) {
                    return "试住";
                }
                if (row.type == 2) {
                    return "预约入住";
                }
                return "其它";
            },
            getTofiexd(row, column, cellValue){
                var data=cellValue
                var list=cellValue.toString().split(".")
                if(list.length==2){
                    if(list[1].length>2){
                        data=cellValue.toFixed(2)
                    }
                }
                return data
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByCheckinStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        isCard:'',
                        checkinStatus:2,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.$nextTick(()=>{
                            this.$refs.historicalFilesTable.doLayout()
                        })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleInfo(row){
                this.checkinDialog=true
                this.loadingInfo=true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Checkin/CheckinByElderlyCode",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyCode:row.elderlyCode,
                    }
                }).then( (response)=> {
                    this.loadingInfo=false
                    if(response.data.error == 0){
                        this.infoData=response.data.data
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>

<style lang='scss' scoped>

/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }

</style>
